import controller from './authorization-form.controller';
import template from './authorization-form.pug';

const AuthorizationFormComponent = {
  template,
  controller,
  bindings: {
    case: '<',
  }
};

export default AuthorizationFormComponent;



// WEBPACK FOOTER //
// ./client/app/cases/authorization-form/authorization-form.component.js